import { render } from "./History.vue?vue&type=template&id=e866d382"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"
script.render = render

export default script